export default {
    wizardType: "GOOGLEADS",

    getConnectionParams: (type, model) => ({
        clientCustomerId: model.get("clientCustomerId"),
        managerId: model.get("managerId"),
        isAutoTokenRenewal: model.get("isAutoTokenRenewal"),
        clientId: model.get("clientId"),
        clientSecret: model.get("clientSecret"),
        refreshToken: model.get("refreshToken"),
        accessToken: model.get("accessToken"),
        developerToken: model.get("developerToken")
    })
};
